// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2mPIp","alert":"SettungsInbox_alert__33ym_"};